// Engine identity, carried by every result (docs/ENGINE-GUIDE.md). GPL-3.0-or-later.
export const ENGINE = { name: "@dipfield/slope", version: "0.3.1" } as const;
